import { Component, OnInit, Input } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { AnalyticsPagePath, Global_Client } from "common";
import { SitefinityPortalMenu, SitefinityMenuItem, ADPResourceService as ResourceService } from "digital-core";
import { filter } from "rxjs/operators";

@Component({
  selector: "portal-menu",
  templateUrl: "./portal-menu.component.html",
  styleUrls: ["./portal-menu.component.css"]
})
export class PortalMenuComponent implements OnInit {
  @Input() menu: SitefinityPortalMenu;
  @Input() menuKey: string;
  @Input() isTopMenu: boolean;

  showMenu: boolean = false;
  applicationType: string;
  private marketingPageArray: string[] = [AnalyticsPagePath.B2CDashboardPath, AnalyticsPagePath.B2CFaqPath,
  AnalyticsPagePath.B2CContactUsPath, AnalyticsPagePath.B2CPricingPath, AnalyticsPagePath.B2CCoveragePath
    , AnalyticsPagePath.B2CCyberProtection, AnalyticsPagePath.B2CTechnicalSupport];
  constructor(private resourceService: ResourceService, private router: Router) {
    router.events.pipe(filter(event => event instanceof NavigationStart),).subscribe((event: NavigationStart) => {
      this.setShowMenu();
    });
  }

  ngOnInit() {
    this.applicationType = this.resourceService.getPortalSetting("Global_Client")?.Value;
  }

  getMenuByOrder(order: number): SitefinityMenuItem {
    // check if left menu was already loaded
    if (!this.menu) {
      return null;
    }
    // get menu item by provided order
    return this.menu.MenuItems.find(x => x.Order === order);
  }

  filteredMenus(): SitefinityMenuItem[] {
    this.setShowMenu();
    if (!!this.menu && !!this.menu.MenuItems && this.showMenu) {
      return this.menu.MenuItems.filter(x => x.LinkUrl && x.Hidden === false);
    } else {
      return [];
    }
  }

  setShowMenu(): void {
    if (!this.applicationType) {
      this.applicationType = this.resourceService.getPortalSetting("Global_Client")?.Value;
    }
    if (this.applicationType.toLocaleLowerCase() == Global_Client.B2B.toLocaleLowerCase()) {
      this.showMenu = true;
      return;
    } else {
      this.showMenu = this.marketingPageArray.some(x => x.toLocaleLowerCase().trim()
        == this.router.url.toLocaleLowerCase().trim());
      return;
    }
  }
}
